export default __webpack_public_path__ + "static/media/sales.a13c596a.svg";